function formatChargeFilter() {
	return function(fee) {
		if(!fee || fee.Value === undefined) {
			return fee; 
		}

		if(fee.Type.Code === "PERCENT") {
			return `${fee.Value}%`;
		} 
		else if(fee.Type.Code === "FLAT") {
			return `$${fee.Value}`;  
		}
		return fee.Value;
	};
}

export default angular
	.module("vesl.filters.formatCharge", [])
	.filter("formatCharge", formatChargeFilter)
	.name;